import { Subject } from 'rxjs';

export class ProgressBarWizardEvents {
    public static GoTo = new Subject<number>();
    public static DetectChanges = new Subject<void>();
    public static ShowButtons = new Subject<boolean>();
    public static CloseWizard = new Subject<void>();
}